// Module
var code = "<div> <button class=btn-confirm type=button name=confirm> </button> <button class=btn-cancel type=button name=cancel> </button> </div>";
// Exports
module.exports = code;